import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthProvider';

type AdministratorRouteProps = {
  children: JSX.Element;
};

const AdministratorRoute = ({
  children,
}: AdministratorRouteProps): JSX.Element => {
  const { isAuthenticated, isAdministrator } = useAuth();

  if (!isAuthenticated) {
    <Navigate to='/' replace={true} />;
  }

  if (!isAdministrator) {
    <Navigate to='/admin/dashboard' replace={true} />;
  }

  return children;
};

export { AdministratorRoute };
